import { server_connection } from 'config';
import { GET_STUDENT_ASSIGNMENT } from './student_assignment.actions';
import { getAllAssignments as lessonGetAllAssignments } from '../../../lesson/store/actions';
import { getRelatedData as lessonGetRelatedData } from '../../../lesson/store/actions';
import { getContentLabelList } from '../../../content_label/store/actions';

import store from 'store';
import history from 'history.js';

export const GET_ASSIGNMENT = '[ASSIGNMENT APP] GET ASSIGNMENT';
export const GET_ASSIGNMENT_BY_EVENT = '[ASSIGNMENT APP] GET ASSIGNMENT BY EVENT';
export const GET_ASSIGNMENT_LIST = '[ASSIGNMENT APP] GET ASSIGNMENT LIST';
export const UPDATE_ASSIGNMENT_FORM = '[ASSIGNMENT APP] UPDATE ASSIGNMENT FORM';
export const UPDATE_ASSIGNMENT_LABELS = '[ASSIGNMENT APP] UPDATE ASSIGNMENT LABELS';
export const DELETE_ASSIGNMENT = '[ASSIGNMENT APP] DELETE ASSIGNMENT';
export const SAVE_ASSIGNMENT = '[ASSIGNMENT APP] SAVE ASSIGNMENT';
export const UPDATE_ASSIGNMENT_LOADED = '[ASSIGNMENT APP] UPDATE ASSIGNMENT LOADED';
export const GET_ASSIGNMENT_DATA = '[ASSIGNMENT APP] GET ASSIGNMENT DATA';
export const DELETE_ASSET = '[ASSIGNMENT APP] DELETE ASSET';
export const GET_ASSIGNMENT_ASSET_LIST = '[ASSIGNMENT APP] GET ASSIGNMENT ASSET LIST';
export const GET_ASSIGNMENT_EDIT_INFO = '[ASSIGNMENT APP] GET ASSIGNMENT EDIT INFO';
export const GET_RELATED_DATA = '[ASSIGNMENT APP] GET RELATED DATA';
export const UPDATE_ASSIGNMENT_LIST_LOADED = '[ASSIGNMENT APP] UPDATE ASSIGNMENT LIST LOADED';

export const LOCK_ASSIGNMENT = '[ASSIGNMENT APP] LOCK ASSIGNMENT';
export const UNLOCK_ASSIGNMENT = '[ASSIGNMENT APP] UNLOCK ASSIGNMENT';
export const ACTIVATE_ASSIGNMENT = '[ASSIGNMENT APP] ACTIVATE ASSIGNMENT';

export const TOGGLE_ASSIGNMENT_REPULL = '[ASSIGNMENT APP] TOGGLE ASSIGNMENT REPULL';

// Assignment -> Lessons
export const GET_ALL_LESSONS = '[ASSIGNMENT APP] GET ALL LESSONS';
export const TOGGLE_LESSON = '[ASSIGNMENT APP] ADD LESSON';
export const LESSON_UPDATE_SEARCH = '[ASSIGNMENT APP] LESSON UPDATE SEARCH';
export const UPDATE_ASSIGNMENT_LESSONS = '[ASSIGNMENT APP] UPDATE ASSIGNMENT LESSONS';

// Assignment -> Quizzes
export const GET_ALL_QUIZZES = '[ASSIGNMENT APP] GET ALL QUIZZES';
export const TOGGLE_QUIZ = '[ASSIGNMENT APP] TOGGLE QUIZ';
export const QUIZ_UPDATE_SEARCH = '[ASSIGNMENT APP] QUIZ UPDATE SEARCH';
export const UPDATE_ASSIGNMENT_QUIZZES = '[ASSIGNMENT APP] UPDATE ASSIGNMENT QUIZZES';
export const CREATE_COPY = '[ASSIGNMENT APP] CREATE_COPY';
export const UPDATE_RTE = '[ASSIGNMENT APP] UPDATE RTE';
export const UPDATE_NEW_ASSIGNMENT_NAME = '[ASSIGNMENT APP] UPDATE NEW ASSIGNMENT NAME';

export const TOGGLE_COMPANY                 = '[MODULE APP] TOGGLE COMPANY';
export const COMPANY_UPDATE_SEARCH          = '[MODULE APP] COMPANY UPDATE SEARCH';

export const GET_COMPANY_LIST               = '[ASSIGNMENT APP] GET COMPANY LIST';
export const PARSE_CONTENT                  = '[ASSIGNMENT APP] PARSE CONTENT';

export const UPDATE_ASSET_NAME              = '[UPDATE ASSET NAME] UPDATE ASSET NAME';

// Determines if Assignment data has been loaded from backend
export function createCopy(assignment_id) {
    return {
        type: CREATE_COPY,
        payload: assignment_id
    }
}

export function handleUpdateRTE() {
    return {
        type: UPDATE_RTE,
        payload: false
    }
}

export function updateAssignmentListLoaded(setting) {
    return {
        type: UPDATE_ASSIGNMENT_LIST_LOADED,
        payload: setting
    }
}

export function saveAssignmentCopy(assignment, quizList, auth_id) {
    const create_id = assignment.header.assignment_id === 0 ? auth_id : assignment.header.CreateAuthID;
    const newAssignment = {
        ...assignment,
        header: {
            ...assignment.header,
            CreateAuthID: create_id,
            LastEditAuthID: auth_id
        }
    }
    return async (dispatch, getState) => {
        await fetch(server_connection + '/assignment/save_copy',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    assignment: newAssignment,
                    quizList: quizList
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                Promise.all([
                    dispatch(getAssignmentList('actions')),
                    dispatch({
                        type: TOGGLE_ASSIGNMENT_REPULL,
                        payload: true,
                    }),
                    history.push({
                        pathname: '/assignment/edit/' + responseData.assignment_id
                    })
                    // dispatch(lessonGetAllAssignments()),
                    // dispatch(lessonGetRelatedData(store.getState().paramHistory.courseBuilder.lesson_id))
                ])
            });
    }
}

export function activateAssignment(assignment_id, auth_id, lessons) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/assignment/activate',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ assignment_id, auth_id, lessons })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: ACTIVATE_ASSIGNMENT,
                    payload: true,
                });
            });
    }
}

export function toggleAssignmentRepull(setting) {
    return {
        type: TOGGLE_ASSIGNMENT_REPULL,
        payload: setting
    }
}

export function updateAssignmentLoaded(setting) {
    return {
        type: UPDATE_ASSIGNMENT_LOADED,
        payload: setting
    }
}

export function getAssignmentAssetList(assignment_id, assetInsertResponse = []) {
    return (dispatch) => {
        fetch(server_connection + '/assignment/asset_list/' + assignment_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_ASSIGNMENT_ASSET_LIST,
                    payload: {responseData, assetInsertResponse},
                });
            });
    }
}

export function getAssignment(assignment_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/assignment/get/' + assignment_id)
            .then((response) => response.json())
            .then((assignmentData) => {
                dispatch({
                    type: GET_ASSIGNMENT,
                    payload: assignmentData,
                });
            });
    }
}

export function getRelatedData(assignment_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/assignment/data/' + assignment_id)
            .then((response) => response.json())
            .then((assignmentData) => {
                dispatch({
                    type: GET_RELATED_DATA,
                    payload: assignmentData,
                });
            });
    }
}

export function getAssignmentEditInfo(assignment_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/assignment/get/edit_info/' + assignment_id)
            .then((response) => response.json())
            .then((assignmentData) => {
                dispatch({
                    type: GET_ASSIGNMENT_EDIT_INFO,
                    payload: assignmentData,
                });
            });
    }
}

export function getAssignmentData(assignment_id) {
    return (dispatch) => {
        Promise.all([
            dispatch(getAssignment(assignment_id)),
            dispatch(getAllLessons()),
            dispatch(getAllQuizzes()),
            dispatch(getAssignmentEditInfo(assignment_id)),
            dispatch(getRelatedData(assignment_id)),
            dispatch(getContentLabelList())
        ]);
    }
}

export function updateAssignmentForm(assignment_data) {
    return {
        type: UPDATE_ASSIGNMENT_FORM,
        payload: assignment_data
    }
}

export function updateAssignmentLabels(assignment_data) {
    return {
        type: UPDATE_ASSIGNMENT_LABELS,
        payload: assignment_data
    }
}

export function saveAssignment(assignment, quizList, auth_id, event_course_status, companies) {
    const create_id = assignment.header.assignment_id === 0 ? auth_id : assignment.header.CreateAuthID;
    const newAssignment = {
        ...assignment,
        header: {
            ...assignment.header,
            CreateAuthID: create_id,
            LastEditAuthID: auth_id,
            labels: assignment.labels,
            newAssignmentAssets: assignment.newAssignmentAssets,
            companies: companies
        }
    }

    return async (dispatch, getState) => {
        await fetch(server_connection + '/assignment/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    assignment:          newAssignment.header,
                    quizList:            quizList,
                    event_course_status: event_course_status,
                    companies,
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                Promise.all([
                    dispatch(getAssignmentList('actions')),
                    dispatch(lessonGetAllAssignments()),
                    dispatch(lessonGetRelatedData(store.getState().paramHistory.courseBuilder.lesson_id))
                ])
            });
    }
}

export function deleteAssignment(assignment_id, auth_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/assignment/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ assignment_id: assignment_id, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                Promise.all([
                    dispatch({
                        type: DELETE_ASSIGNMENT,
                        payload: assignment_id,
                    }),
                    dispatch(lessonGetAllAssignments()),
                    dispatch(getAssignmentList('actions'))
                    //this was here when you could delete an assignment from inside the scope of a lesson. Needed to bring 
                    // in all the data for the lesson schedule again.
                    // dispatch(lessonGetRelatedData(store.getState().paramHistory.courseBuilder.lesson_id))
                ])
            });
    }
}

export function getAssignmentList(call_location) {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch, getState) => {
        fetch(server_connection + '/assignment/list/' + auth_id)
            .then((response) => response.json())
            .then((assignmentList) => {
                dispatch({
                    type: GET_ASSIGNMENT_LIST,
                    payload: {assignmentList, call_location}
                });
            });
    }
}
// Assignment -> Lesson 

export function lessonUpdateSearch(characters) {
    return {
        type: LESSON_UPDATE_SEARCH,
        payload: characters
    }
}

export function toggleLesson(lesson, action_type) {
    return {
        type: TOGGLE_LESSON,
        payload: { lesson: lesson, action_type: action_type }
    }
}

export function getAllLessons() {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch) => {
        return fetch(server_connection + '/lesson/list/' + auth_id)
            .then((response) => response.json())
            .then((allLessons) => {
                return dispatch({
                    type: GET_ALL_LESSONS,
                    payload: allLessons
                })
            })
    }
}

export function updateAssignmentLessons(lessons, assignment_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/assignment/update/lessons',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ lessons: lessons, assignment_id: assignment_id })
            })
            .then((response) => JSON.stringify(response))
            .then((responseData) => {
                dispatch({
                    type: UPDATE_ASSIGNMENT_LESSONS,
                });
            });
    }
}

// Assignment -> Quiz 

export function quizUpdateSearch(characters) {
    return {
        type: QUIZ_UPDATE_SEARCH,
        payload: characters
    }
}

export function toggleQuiz(quiz, action_type) {
    return {
        type: TOGGLE_QUIZ,
        payload: { quiz, action_type }
    }
}

export function getAllQuizzes() {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch) => {
        return fetch(server_connection + '/quiz/list/' + auth_id)
            .then((response) => response.json())
            .then((allQuizzes) => {
                return dispatch({
                    type: GET_ALL_QUIZZES,
                    payload: allQuizzes
                })
            })
    }
}

export function updateAssignmentQuizzes(quizzes, assignment_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/assignment/update/quizzes',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ quizzes: quizzes, assignment_id: assignment_id })
            })
            .then((response) => JSON.stringify(response))
            .then((responseData) => {
                dispatch({
                    type: UPDATE_ASSIGNMENT_QUIZZES,
                });
            });
    }
}

export function lockAssignment(assignment_id, auth_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/assignment/lock',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ assignment_id, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: LOCK_ASSIGNMENT,
                    payload: auth_id
                });
            });
    }
}

export function unlockAssignment(assignment_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/assignment/unlock',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ assignment_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: UNLOCK_ASSIGNMENT,
                    payload: true,
                });
            });
    }
}

export function getCompanyList() {
    return (dispatch, getState) => {
        fetch(server_connection + '/company/list')
            .then((response) => response.json())
            .then((companyList) => {
                dispatch({
                    type: GET_COMPANY_LIST,
                    payload: companyList,
                });
            });
    }
}

export function updateNewAssignmentName(data) {
    return {
        type: UPDATE_NEW_ASSIGNMENT_NAME,
        payload: data
    }
}

export function companyUpdateSearch(characters) {
    return {
        type: COMPANY_UPDATE_SEARCH,
        payload: characters
    }
}

export function toggleCompany(company, action_type) {
    return {
        type: TOGGLE_COMPANY,
        payload: { company, action_type }
    }
}

export function updateAssetName(newName, asset_id, saved) {
    return {
        type: UPDATE_ASSET_NAME,
        payload: {newName, asset_id, saved}
    }
}


// WEBPACK FOOTER //
// src/main/content/assignment/store/actions/assignment.actions.js